import axios from 'axios';

const httpClient = axios.create({
  baseURL: process.env.VUE_APP_APIURL,  
  headers: {
    'Ocp-Apim-Subscription-Key': process.env.VUE_APP_OCP_APIM_SUBSCRIPTION_KEY
  }
});

export default httpClient;
